import React, { useEffect } from "react";
import { Input, Label } from "reactstrap";
import { connect } from "react-redux";
import { find, map } from "lodash";
import CurrencyFormat from "react-currency-format";
import moment from "moment";

import { getBrands, getModels } from "../../../../redux/actions/spiderActions";

import { vehicleTypeList } from "../../../../helper/constants";
import { vehicleTypeFormatter } from "../../../../helper/functions";

const CRMComponent = ({
  valuesHandler,
  getBrands,
  getModels,
  brands,
  models,
}) => {

  useEffect(() => {
    if (values.typeVehicle) {
      getBrands(vehicleTypeFormatter(values.typeVehicle), (res) => {
        let brand = find(res, (e) => e.VeMNombre === values.brand);
        setStateValue('brandId', (brand && brand.VemCodigoMarca) || '');
        getModels(vehicleTypeFormatter(values.typeVehicle), brand && brand.VemCodigoMarca);
      });
    }
  }, []);

  const { values, setStateValue } = valuesHandler;

  const handleChangeVehicleType = (e) => {
    setStateValue('typeVehicle', e.target.value);
    setStateValue('brandId', '');
    setStateValue('model', '');
    getBrands(vehicleTypeFormatter(e.target.value));
  }

  const handleChangeBrand = (e) => {
    setStateValue('brand', e.target.options[e.target.options.selectedIndex].label);
    setStateValue('brandId', e.target.value);
    setStateValue('model', '');
    getModels(vehicleTypeFormatter(values.typeVehicle), e.target.value);
  }

  return (
    <div>
      <div className="crm-modal-form-group" >
        <div className="crm-modal-input-group">
          <Label for='vehicle-type' >*Tipo de vehículo</Label>
          <Input
            className='crm-modal-input-text'
            name='vehicle-type'
            id='vehicle-type'
            type='select'
            value={values.typeVehicle}
            onChange={handleChangeVehicleType}
          >
            <option key='select' value=''>
              Seleccione
            </option>
            {map(vehicleTypeList, (e) => (
              <option key={e.id} value={e.value}>
                {e.label}
              </option>
            ))}
          </Input>
        </div>
        <div className="crm-modal-input-group">
          <Label for='brand'>Marca</Label>
          <Input
            className='crm-modal-input-text'
            name='brand'
            id='brand'
            type='select'
            value={values.brandId}
            onChange={handleChangeBrand}
            required
            disabled={!values.typeVehicle || brands.loading}
          >
            <option key='select' value=''>
              Seleccione
            </option>
            {map(brands.data, (e, index) => (
              <option key={`${e.VemCodigoMarca}-${index}`} value={e.VemCodigoMarca}>
                {e.VeMNombre}
              </option>
            ))}
          </Input>
        </div>
      </div>
      <div className="crm-modal-form-group" >
        <div className="crm-modal-input-group">
          <Label for='model'>Modelo</Label>
          <Input
            className='crm-modal-input-text'
            name='model'
            id='model'
            type='select'
            value={values.model}
            required
            disabled={!values.brand || models.loading}
            onChange={(e) => setStateValue('model', e.target.value)}
          >
            <option key='select' value=''>
              Seleccione
            </option>
            {map(models.data, (e, index) => (
              <option key={`${e.VMoCodigoModelo}-${index}`} value={e.VMoModelo}>
                {e.VMoModelo}
              </option>
            ))}
          </Input>
        </div>
        <div className="crm-modal-input-group">
          <Label for='year'>Año</Label>
          <Input
            className='crm-modal-input-text'
            type='number'
            name='year'
            id='year'
            value={values.year}
            onChange={(e) => setStateValue('year', e.target.value)}
            min='1990'
            max={moment().add(1, "y").format("YYYY")}
            required
          />
        </div>
      </div>
      <div className="crm-modal-form-group" >
        <div className="crm-modal-input-group">
          <Label for='vehicle-price'>Precio vehículo</Label>
          <CurrencyFormat
            className='crm-modal-input-text'
            name='vehicle-price'
            id='vehicle-price'
            value={values.priceVehicle}
            onChange={(e) => setStateValue('priceVehicle', e.target.value.replace(/[^,0-9\s]/gi, ''))}
            decimalSeparator=","
            thousandSeparator="."
            prefix={"$"}
            customInput={Input}
            required
          />
        </div>
        <div className="crm-modal-input-group">
          <Label for='initialPayment'>Monto pie</Label>
          <CurrencyFormat
            className='crm-modal-input-text'
            name='initialPayment'
            id='initialPayment'
            value={values.initialPayment}
            onChange={(e) => setStateValue('initialPayment', e.target.value.replace(/[^,0-9\s]/gi, ''))}
            decimalSeparator=","
            thousandSeparator="."
            prefix={"$"}
            customInput={Input}
            required
          />
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = ({ spider }) => ({
  brands: spider.brands,
  models: spider.models,
});

const mapDispatchToProps = {
  getBrands,
  getModels,
};

export default connect(mapStateToProps, mapDispatchToProps)(CRMComponent);